import { RootState } from '../../store/root-state';

export const getCompaniesState = (state: RootState) => state.companies.companies;
